module.exports = __webpack_public_path__ + "static/media/2 demon horns color leg.1280x1507.cc3bb7ad.webp";